(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["deck.bnorm.dev"] = factory();
	else
		root["deck.bnorm.dev"] = factory();
})(globalThis, () => {
return 